<template>
    <with-dimensions v-if="data.length > 0">
        <div
            slot-scope="{ width }"
            class="relative bg-white rounded shadow pt-1-5"
        >
            <div class="absolute inset-x-0 top-0 rounded-t bg-red h-1-5" />

            <div
                :class="width > 500 ? 'p-6' : 'p-3'"
                class="flex w-full"
            >
                <base-svg
                    name="icon-important-circle-large"
                    :class="width > 500 ? 'w-8 h-8 mr-4' : 'w-6 h-6 mr-3'"
                    class="flex-none fill-primary-red-dark fill-secondary-red-light"
                />

                <div class="flex-grow">
                    <h3
                        :class="width > 500 ? 'py-1' : ''"
                        class="flex-grow text-base font-normal"
                    >
                        Alerts
                    </h3>

                    <component
                        v-for="alert in data"
                        :is="alert.path ? 'router-link' : 'div'"
                        :key="alert.uuid"
                        :to="alert.path"
                        :class="{'text-blue' : !!alert.path}"
                        class="block mt-2 no-underline md:mt-3"
                    >
                        <div class="text-sm">{{ alert.title }}</div>
                        <div class="text-xs text-grey-darker">{{ alert.description }}</div>
                    </component>
                </div>
            </div>

            <div
                v-if="meta.last_page > meta.page"
                class="px-4 py-2 text-sm font-semibold bg-grey-bg text-grey-darker sm:px-6"
            >
                <base-more
                    :to="moreTo"
                    :count="meta.count"
                    :total="meta.total"
                />
            </div>
        </div>
    </with-dimensions>
</template>

<script>
    export default {
        props: {
            data: {
                type: Array,
                required: true
            },
            meta: {
                type: Object,
                required: true
            },
            moreTo: {
                type: Object,
                default () {
                    return {
                        name: this.$router.fix('dashboard.*.alerts.index')
                    }
                }
            }
        }
    }
</script>
